import posthog from "posthog-js";

let initialized = false;

export const initPostHog = () => {
  if (typeof window === "undefined") {
    return;
  }

  if (initialized) {
    return;
  }

  const apiKey = process.env.GATSBY_POSTHOG_API_KEY;
  const apiHost = process.env.GATSBY_POSTHOG_API_HOST;

  posthog.init(apiKey, {
    api_host: apiHost,
    capture_pageview: false,
    autocapture: false,
    loaded: () => {
      initialized = true;
    },
  });
};

export const capture = (event, properties = {}) => {
  if (typeof window === "undefined" || !initialized) {
    return;
  }

  posthog.capture(event, properties);
};
